module.exports = __webpack_public_path__ + "static/emmaus_logo-124d9dbb9fd002cf05d6f3f30f6e7966.png";